<ng-container [ngSwitch]="currentEditMode">
    <ng-container *ngSwitchCase="'section'">
        <ng-container [ngSwitch]="title">
            <ng-container *ngSwitchCase="'Layout'">
                <kve-banner-cell-layout [imageOrientation]="imageOrientation" [bannerCellLayoutClassList]="bannerCellLayoutClassList"></kve-banner-cell-layout>
                <!-- <kve-cell-layout-editor
                    [section]="section"
                    [cellId]="cellId"
                    [selectedCell]="selectedCell">
                </kve-cell-layout-editor> -->
            </ng-container>
            <ng-container *ngSwitchCase="'Theme'">
                <kve-cell-theme-editor
                    [section]="section"
                    [cellId]="cellId"
                    [selectedCell]="selectedCell">
                </kve-cell-theme-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'Background'">
                <kve-cell-bg-editor class="vertical"
                    [section]="section"
                    [cellId]="cellId"
                    [selectedCell]="selectedCell"
                    tabbed=true></kve-cell-bg-editor>
               
            </ng-container>
            <ng-container *ngSwitchCase="'Image'">

            </ng-container>                 
        </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="EditMode.CELL">
        <ng-container [ngSwitch]="contentEnum">
            <ng-container *ngSwitchCase="'Banner'">
                <kve-banner-cell-layout [imageOrientation]="imageOrientation" [bannerCellLayoutClassList]="bannerCellLayoutClassList"></kve-banner-cell-layout>
            </ng-container>
            <ng-container *ngSwitchCase="'BANNER'">
                <kve-banner-cell-layout [imageOrientation]="imageOrientation" [bannerCellLayoutClassList]="bannerCellLayoutClassList"></kve-banner-cell-layout>
            </ng-container>
            <ng-container *ngSwitchCase="'Hero Image'">
                <kve-hero-image-layout-templates></kve-hero-image-layout-templates>
                <!-- <kve-banner-cell-layout [imageOrientation]="imageOrientation" [bannerCellLayoutClassList]="bannerCellLayoutClassList"></kve-banner-cell-layout> -->
            </ng-container>
            <ng-container *ngSwitchCase="'HERO_IMAGE'">
                <kve-hero-image-layout-templates></kve-hero-image-layout-templates>
            </ng-container>
            <ng-container *ngSwitchCase="'ContentEnum.HERO_IMAGE'">
                <kve-hero-image-layout-templates></kve-hero-image-layout-templates>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'contentElement'">
        <kve-cell-theme-editor
                    [section]="section"
                    [cellId]="cellId"
                    [selectedCell]="selectedCell"
                    [status]="status">
                </kve-cell-theme-editor>
        <!-- <ng-container [ngSwitch]="rendererType">
            <ng-container *ngSwitchCase="'grid'">
                <ng-container [ngSwitch]="contentEnum">
                    <ng-container *ngSwitchCase="'Banner'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId" [orientation]="orientation" [context]="context"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Link'">
                        <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'GRID'">
                <ng-container [ngSwitch]="contentEnum">
                    <ng-container *ngSwitchCase="'Banner'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId" [orientation]="orientation" [context]="context"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'BANNER'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId" [orientation]="orientation" [context]="context"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Link'">
                        <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'product'">
                <ng-container [ngSwitch]="contentEnum">
                    <ng-container *ngSwitchCase="'Gallery'">
                        <div class="editor-header gallery-header">Gallery</div>
                        <div class="editor-content-selectors gallery-editor">
                            <div *ngFor="let contentElement of selectedCell?.contentElements" class="image-container" (click)="pickGalleryImage(contentElement)">
                                <img [src]="contentElement.imgSrc">
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Identification'">
                        <kve-identification-editor [contentElements]="selectedCell?.contentElements"></kve-identification-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Classification'">
                        <kve-product-classification [contentElements]="selectedCell?.contentElements"></kve-product-classification>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Variant'">
                        <kve-variant-editor [contentElements]="selectedCell?.contentElements"></kve-variant-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Price'">
                        <kve-price-editor [contentElements]="selectedCell?.contentElements"></kve-price-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Short Description'">
                        <div class="editor-header">Product Short Description</div>
                        <div class="editor-content-selectors">
                            <kve-description-editor [contentElements]="selectedCell?.contentElements"></kve-description-editor>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Long Description'">
                        <div class="editor-header">Product Long Description</div>
                        <div class="editor-content-selectors">
                            <kve-long-description-editor [contentElements]="selectedCell?.contentElements"></kve-long-description-editor>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Rating'">
                        <div class="editor-header">Product Rating</div>
                        <div class="editor-content-selectors">
                            <kve-ratings-editor [contentElements]="selectedCell?.contentElements"></kve-ratings-editor>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Share'">
                        <div class="editor-header">Product Share</div>
                        <div class="editor-content-selectors">
                            <kve-product-share-editor [contentElements]="selectedCell?.contentElements"></kve-product-share-editor>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Standard Features'">
                        <kve-features-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" featureType="standard"></kve-features-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Selectable Features'">
                        <kve-features-editor  [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" featureType="selectable"></kve-features-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Add To Cart'">
                        <kve-add-to-cart-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" featureType="selectable"></kve-add-to-cart-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Banner'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Cell'">
                        <kve-row-cell-editor [contentElements]="selectedCell?.contentElements"></kve-row-cell-editor>
                        
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="RendererType.BANNER">
                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId" [context]="context"></kve-banner-cell-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'RendererType.BANNER'">
                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId" [context]="context"></kve-banner-cell-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'testimonials'">
                <kve-testimonial-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section"></kve-testimonial-cell-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'slider'">
                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'hero-image'">
                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'row'">
                <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
            </ng-container>
            <ng-container *ngSwitchCase="'bloglist'">
                <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell?.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <kve-cell-theme-editor
                    [section]="section"
                    [cellId]="cellId"
                    [selectedCell]="selectedCell"
                    [trackStatus$]="trackStatus$.asObservable()">
                </kve-cell-theme-editor>
            </ng-container>
        </ng-container> -->
    </ng-container>
    <ng-container *ngSwitchDefault>
        <kve-cell-theme-editor
            [section]="section"
            [cellId]="cellId"
            [selectedCell]="selectedCell"
            [status]="status">
        </kve-cell-theme-editor>
    </ng-container>
</ng-container>

